const adsGramLoadPromise = new Promise<any>((resolve, reject) => {
  // Завантажуємо скрипт AdsGram SDK для браузерів (без перевірки cc.sys)
  const script = document.createElement('script')
  script.src = 'https://sad.adsgram.ai/js/sad.min.js'
  script.async = true
  script.onload = () => {
    const intervalId = setInterval(() => {
      if ((window as any).Adsgram) {
        resolve((window as any).Adsgram)
        clearInterval(intervalId)
      }
    }, 100)
  }
  script.onerror = () => reject(new Error('Unable to load AdsGram SDK, please check logs.'))
  document.head.appendChild(script)
})

export class AdsGramController {
  private static _instance: AdsGramController
  private constructor() {}
  public static get Instance(): AdsGramController {
    if (!AdsGramController._instance) {
      AdsGramController._instance = new AdsGramController()
    }
    return AdsGramController._instance
  }

  private _adsGramJS: any = null
  private rewarded_adController: AdController | null = null
  private interstitial_adController: AdController | null = null

  public async init(): Promise<{ success: boolean }> {
    try {
      this._adsGramJS = await adsGramLoadPromise
      return { success: !!this._adsGramJS }
    } catch (error) {
      console.warn('Failed to load AdsGram SDK:', error)
      return { success: false }
    }
  }

  public getAdsGram() {
    return this._adsGramJS
  }

  public initAdsControllers() {
    if (!this._adsGramJS) {
      console.warn('AdsGram SDK not loaded yet.')
      return
    }

    this.rewarded_adController = this._adsGramJS.init({
      blockId: '12387',
      // debug: true,
      debugBannerType: 'FullscreenMedia',
    })

    this.interstitial_adController = this._adsGramJS.init({
      blockId: 'int-9540',
      // debug: true,
      debugBannerType: 'FullscreenMedia',
    })
  }

  public showAd_Rewarded(): Promise<ShowPromiseResult> {
    if (!this.rewarded_adController) return Promise.reject(new Error('Rewarded ad controller not initialized'))
    return this.rewarded_adController.show()
  }

  public showAd_Interstitial(): Promise<ShowPromiseResult> {
    if (!this.interstitial_adController) return Promise.reject(new Error('Interstitial ad controller not initialized'))
    return this.interstitial_adController.show()
  }

  public showFullscreenAd() {
    if (!this.rewarded_adController) {
      console.warn('Rewarded ad controller not initialized')
      return
    }
    this.rewarded_adController
      .show()
      .then((result: ShowPromiseResult) => {
        console.log(`AdsGram ad watched ${result}`)
      })
      .catch((result: ShowPromiseResult) => {
        console.log(`AdsGram ad error: ${result}`)
      })
  }
}

export interface ShowPromiseResult {
  done: boolean
  description: string
  state: 'load' | 'render' | 'playing' | 'destroy'
  error: boolean
}

type BannerType = 'RewardedVideo' | 'FullscreenMedia'

interface AdsgramInitParams {
  blockId: string
  debug?: boolean
  debugBannerType?: BannerType
}

type EventType = 'onReward' | 'onComplete' | 'onStart' | 'onSkip' | 'onBannerNotFound' | 'onNonStopShow' | 'onError'
type HandlerType = () => void

export interface AdController {
  show(): Promise<ShowPromiseResult>
  addEventListener(event: EventType, handler: HandlerType): void
  removeEventListener(event: EventType, handler: HandlerType): void
  destroy(): void
}

declare global {
  interface Window {
    Adsgram?: {
      init(params: AdsgramInitParams): AdController
    }
  }
}
